import { ErrorHandler, Injectable, inject } from '@angular/core';

import { HisBackendService } from './his-backend.service';

export class ServerLogEntry {
    fileName: string;
    message: string;
    stack: string;
}

@Injectable({providedIn: 'root'})
export class HisErrorHandler implements ErrorHandler {
    private hisBackendService = inject(HisBackendService);


    private lastError?: ServerLogEntry;
    private errorCounter = 0;

    public handleError( error: any ) {
        console.error( error );

        // 422: Validation Error, 409: Conflict
        if ( error.status === 422 || error.status === 409 ) {
            return;
        }

        // Limit number of error reports because the same error might
        // occur hundreds of times during change detection (anfrage 328763)
        if (this.errorCounter > 5) {
            return;
        }

        let data: ServerLogEntry = {
            fileName: error.fileName,
            message: error.message,
            stack: error.stack,
        };

        if (this.lastError === data) {
            return;
        }
        this.lastError = data;
        this.errorCounter++;
        this.hisBackendService.postData( 'api/v1/cs/sys/log/error', data ).subscribe(
            ( answer ) => { console.log( answer ); } );
    }
}
